// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z_dc","textarea":"styles_textarea__a9_ml"};